// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p7KC","content":"styles_content__26pp1"};